import React, { useContext } from "react";
import appStoreBadge from "../../assets/appstore-download-badge.png";
import googlePlayBadge from "../../assets/google-play-download-badge.png";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { I18nContext } from "../../providers/i18n";
import "./index.scss";

const googlePlayLink =
  "https://play.google.com/store/apps/details?id=ch.easyvote.votenow";
const appStoreLink =
  "https://itunes.apple.com/us/app/votenow/id1450750592?l=de&ls=1&mt=8";

const StartPage = () => {
  const { t } = useContext(I18nContext);
  return (
    <div className="StartPage">
      <div className="header-container">
        <Header />
      </div>
      <div className="content">
        <div className="text">
          <p>{t("webOnly.welcomeText.firstPart")}</p>
          <p>{t("webOnly.welcomeText.secondPart")}</p>
          <p>{t("webOnly.welcomeText.thirdPart")}</p>
        </div>

        <div className="download-badges">
          <a href={appStoreLink}>
            <img
              className="app-store-badge"
              src={appStoreBadge}
              alt={"AppStore badge"}
            />
          </a>
          <a href={googlePlayLink}>
            <img
              className="google-play-badge"
              src={googlePlayBadge}
              alt={"Google Play badge"}
            />
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StartPage;
